import React from 'react'
import { connect } from 'react-redux'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import { Tabs } from 'antd'
import AddNewCard from '../AddNewCard'
import CardPay from '../CardPay'
import _ from 'lodash'

import { devicePay } from 'utils'
import DevicePay from '../DevicePay'
import MessagePay from '../MessagePay'
import App from '../App'
import AliPay from '../AliPay'
import AaniPay from '../AaniPay'

class Container extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
    }
  }

  componentDidMount = async () => {
    if (this.props.data && !_.isEqual(this.state.data, this.props.data)) {
      const data = await devicePay.filter(_.clone(this.props.data))
      const preferred = _.find(data, devicePay.preferred())
      preferred && _.remove(data, preferred)
      this.setState({
        data,
      })
      console.log(this.state.data, 1)
    }
  }

  render() {
    const {
      siteConfig,
      selected,
      actions,
      submit,
      loading,
      optAddCardItems,
      optAppItems,
      pageName,
      orderLabel,
      saveCard
    } = this.props
    return (
      <Tabs
        destroyInactiveTabPane
        animated={false}
        className={classes.componentsPaymentMethodsContainer}
        activeKey={selected || '0'}
      >
        {this.state.data.map((item, index) => {
          const cardList = _.filter(
            item.payMethods,
            {
              type: 'PAYPAGE_CARD_PAY',
            },
            []
          )
          const canAddCard = _.filter(
            item.payMethods,
            {
              type: 'CARD_TOKEN',
            },
            []
          )
          switch (item.tabType) {
            case 'PAY_METHODS':
              return (
                <Tabs.TabPane key={index} tab>
                  {siteConfig.loginToken ? (
                    <CardPay
                      {...item}
                      actions={actions}
                      submit={submit}
                      loading={loading}
                      optAddCardItems={optAddCardItems}
                      cardList={cardList}
                      canAddCard={!!canAddCard.length}
                      pageName={pageName}
                      saveCard={saveCard}
                    />
                  ) : (
                    <AddNewCard
                      {...item}
                      submit={submit}
                      loading={loading}
                      optAddCardItems={optAddCardItems}
                      pageName={pageName}
                    />
                  )}
                </Tabs.TabPane>
              )
            case 'MESSAGE_PAY':
              return (
                <Tabs.TabPane key={index} tab>
                  <MessagePay
                    {...item}
                    submit={submit}
                    loading={loading}
                    pageName={pageName}
                  />
                </Tabs.TabPane>
              )
            case 'APP':
              return (
                <Tabs.TabPane key={index} tab>
                  <App
                    {...item}
                    submit={submit}
                    loading={loading}
                    optAppItems={optAppItems}
                    pageName={pageName}
                  />
                </Tabs.TabPane>
              )
            case 'DEVICE_PAY':
              return (
                <Tabs.TabPane key={index} tab>
                  <DevicePay
                    {...item}
                    actions={actions}
                    item={item}
                    siteConfig={siteConfig}
                    submit={submit}
                    orderLabel={orderLabel}
                  />
                </Tabs.TabPane>
              )
            case 'WALLET_PAY':
              return (
                <Tabs.TabPane key={index} tab>
                  <AliPay
                    {...item}
                    actions={actions}
                    item={item}
                    siteConfig={siteConfig}
                    submit={submit}
                    orderLabel={orderLabel}
                  />
                </Tabs.TabPane>
              )
            case 'MIX_PAY':
              return (
                <Tabs.TabPane key={index} tab>
                  <AaniPay
                    {...item}
                    actions={actions}
                    item={item}
                    siteConfig={siteConfig}
                    submit={submit}
                    orderLabel={orderLabel}
                  />
                </Tabs.TabPane>
              )
          }
        })}
      </Tabs>
    )
  }
}

export default connect(
  (state) => ({
    siteConfig: state.siteConfig,
  }),
  {}
)(Container)

/*
  隐藏Tabs组建的标题栏，仅作为支付方式组件的容器，控制加载全部的组件，
  和PaymentMethodSelector和PaymentMethodSwitcher组合使用
*/
